<template>
	<v-card elevation="0" class="height-100 mt-3">
		<v-card-title>
			<v-btn-toggle v-model="queryParam.state" @change="searchQuery" color="primary" mandatory dense group class="ml-n2">
				<v-btn :value="item.key" class="ml-2" v-for="(item, index) in btnGroup" :key="index">{{ item.val }}</v-btn>
			</v-btn-toggle>
			<v-spacer />
			<vtk-area-tabs v-model="queryParam.areas" @change="searchQuery" :minArea="6" :fixed="2" :styles="'max-width: 380px'" hide-details />
		</v-card-title>
		<v-card-text>
			<!-- @click:row="toView" -->
			<v-data-table :headers="headers" :items="desserts" :loading="loading" disable-pagination loading-text="数据加载中..." class="elevation-0 vtk-cursor-pointer" hide-default-footer>
				<template v-slot:[`item.first_col`]="{ item }">
					<span>{{ desserts.indexOf(item) + 1 }}</span>
				</template>

				<template v-slot:[`item.areaName`]="{ item }">
					<v-chip class="mr-2 areaChip px-2" :class="item.areaCode.length | dict('1:red--text bgRed/2:blue--text bgBlue/4:green--text bgGreen/6:orange--text bgOrange')" small label>{{ item.areaCode.length | dict("1:国家/2:省级/4:市级/6:区县") }}</v-chip>
					<span>{{ item.areaName }}</span>
				</template>

				<template v-slot:[`item.linkTele`]="{ item }"> {{ item.linkTele | mobile }} </template>

				<template v-slot:[`item.state`]="{ item }">
					<v-chip class="white--text" :class="item.state | dict('0:blue/1:green/2:red')" small> {{ item.state | dict("0:申请中/1:已通过/2:未通过") }} </v-chip>
				</template>

				<template v-slot:[`item.etime`]="{ item }">
					{{ item.btime | date("yyyy-MM-dd") }} ~
					{{ item.etime | date("yyyy-MM-dd") }}
				</template>

				<template v-slot:[`item.operateTime`]="{ item }">
					{{ item.operateTime | date("yyyy-MM-dd HH:mm:ss") }}
				</template>

				<template v-slot:[`item.note`]="{ item }">
					{{ item.note | txt(32) }}
				</template>

				<template v-slot:[`item.actions`]="{ item }">
					<span @click="toView(item)" class="blue--text">详情</span>
					<span v-if="item.state != 1" @click="toEdit(item)" class="green--text ml-3">修改</span>
				</template>

				<template v-slot:no-data>
					<v-card class="px-6 pt-4 pb-4 mt-3" elevation="0" id="train">
						<p class="grey--text mt-4">暂无数据</p>
					</v-card>
				</template>
			</v-data-table>
			<v-divider />
			<pagination :page-sizes="[10, 20]" :page-data="pageData" @pageChange="getListPage" />
		</v-card-text>
		<!-- 申请进度 -->
		<dept-ureg-view ref="mView" />
		<!-- 编辑 -->
		<dept-input ref="Madd" />
	</v-card>
</template>

<script>
// import Request from "@/commons/request";
import Storage from "@/commons/storage";
// import Message from "@/components/message";
import Mixins from "@/compositions/mixins/minxs";
import pagination from "@/components/pagination";
import DeptUregView from "./dept-ureg-view";
import DeptInput from "./dept-input";
export default {
	mixins: [Mixins],
	components: { pagination, DeptUregView, DeptInput },
	data() {
		return {
			desserts: [],
			url: { list: "/udsx/dept-ureg/page", datele: "/udsx/dept-ureg/delete" },
			headers: [
				{ text: "序号", value: "first_col", sortable: false, width: 60, align: "center" },
				{ text: "服务地区", value: "areaName", sortable: false },
				{ text: "服务时间", value: "etime", sortable: false },
				{ text: "联系人员", value: "linkName", sortable: false, width: 130 },
				{ text: "联系电话", value: "linkTele", sortable: false, width: 160 },
				{ text: "状态", value: "state", sortable: false, width: 130, align: "center" },
				// { text: "申请说明", value: "note", sortable: false },
				{ text: "操作时间", value: "operateTime", sortable: false, width: 200 },
				{ text: "操作", value: "actions", sortable: false, width: 110 },
			],
			btnGroup: [
				{ key: "A", val: "全部" },
				{ key: "0", val: "申请中" },
				{ key: "1", val: "已通过" },
				{ key: "2", val: "未通过" },
			],
			queryParam: { state: "A" },
		};
	},
	activated() {
		this.refresh();
	},
	methods: {
		refresh() {
			this.queryParam.did = Storage.get("_wit_acis_users").did;
			this.queryParam.bid = this.$route.query.pid;
			this.loadPage();
		},
		toView(item) {
			this.$refs.mView.view(item);
		},
		toEdit(item) {
			this.$refs.Madd.edit(item, 2);
		},
	},
};
</script>

<style lang="scss" scoped>
::v-deep {
	td.text-start:nth-child(2) {
		min-width: 200px;
	}
}
.bgRed {
	background: #e91e6318 !important;
}
.bgGreen {
	background: #4caf5018 !important;
}
.bgBlue {
	background: #2196f318 !important ;
}
.bgOrange {
	background: #ff980018 !important;
}
</style>
